import React from 'react'
import PropTypes from 'prop-types'
import { HippostdHtml } from './HippostdHtml.jsx'
import { CtiLinkList } from './CtiLinkList.jsx'

const CtiBlogParagraph = ({
  paragraphTitle,
  paragraphHTML,
  paragraphLinks,
  classNames,
}) => {
  const { value } = paragraphHTML
  const { links } = paragraphLinks

  // links are required to have a linkHref otherwise its useless
  const removeInsufficientLinks = (linklist) => {
    return linklist.reduce((acc, curr) => {
      if (curr.link[0]?.linkHref) {
        acc.push(curr)
      }
      return acc
    }, [])
  }

  const leftoverLinks = removeInsufficientLinks(links)
  return paragraphTitle || value || leftoverLinks.length > 0 ? (
    <div className={`CtiBlogParagraph ${classNames || ''}`}>
      {paragraphTitle && <h3>{paragraphTitle}</h3>}
      {value && <HippostdHtml value={value} />}
      {leftoverLinks.length > 0 ? (
        <CtiLinkList
          links={links}
          buttonClasses="u-textColorBrandLight u-decoBorderBrandLight"
        />
      ) : null}
    </div>
  ) : null
}

CtiBlogParagraph.propTypes = {
  paragraphTitle: PropTypes.string,
  paragraphHTML: PropTypes.shape({
    contentType: PropTypes.string,
    value: PropTypes.string,
  }),
  paragraphLinks: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        displayName: PropTypes.string,
        icon: PropTypes.string,
        link: PropTypes.array,
        text: PropTypes.string,
        description: PropTypes.string,
        asButton: PropTypes.bool,
        target: PropTypes.string,
        contentType: PropTypes.string,
      })
    ),
    tableHeader: PropTypes.string,
    contentType: PropTypes.string,
  }),
  classNames: PropTypes.string,
}

export { CtiBlogParagraph }
